import React, { Component } from 'react';

import { Region } from 'C4';
import ReservationsInfo from './ReservationsInfo';

const avatar = 'https://front.travpromobile.com/678/avatar_unknown.svg';

const regions = {
  asia: {
    name: 'Asia Pacific',
    reservationsInfo: [
      {
        country: 'Hong Kong',
        telephone: '800-96-2518 toll free',
      },
      {
        country: 'India',
        telephone: '000800-650-1240 toll free',
      },
      {
        country: 'Indonesia',
        telephone: '001-803-65-6609 toll free',
      },
      {
        country: 'Japan',
        telephone: '0120-086-230 toll free',
      },
      {
        country: 'Malaysia',
        telephone: '1-800-80-1006 toll free',
      },
      {
        country: "People's Republic of China",
        telephone: '400-1324-582',
      },
      {
        country: 'Phillipines',
        telephone: '1-800-1-65-1-0235 toll free',
      },
      {
        country: 'Singapore',
        telephone: '1-800-737-9955 toll free',
      },
      {
        country: 'South Korea',
        telephone: '001-800-5210-5131 toll free',
      },
      {
        country: 'Taiwan',
        telephone: '00801-65-1223 toll free',
      },
      {
        country: 'Thailand',
        telephone: '001-800-65-6099 toll free',
      },
      {
        country: 'Australia',
        telephone: '61-2 9377-8444',
      },
      {
        country: 'New Zealand',
        telephone: '0-800-44-1016',
      },
    ],
    offices: [
      {
        office: 'Tokyo',
        salesRegion: 'Japan',
        adressLines: [
          '2F, 1-3-27 Shimomeguro, Merugo-ku',
          'Tokyo 153-0064, Japan',
        ],
        contacts: [
          {
            name: 'Shingo Hirao',
            description: 'Director, Japan',
            telephone: '81 3 5436 8115',
            mail: 'shirao@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/shingo.png',
          },
        ],
      },
      {
        office: 'Seoul',
        salesRegion: 'Korea',
        adressLines: [
          '16F, Tower 8',
          '7 Jongro 5-gil, Jongro-gu',
          'Seoul 03157, Korea',
        ],
        contacts: [
          {
            name: 'Richard Kim',
            description: 'Director, Korea',
            telephone: '82 2 6227 7227',
            mail: 'rkim@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/Richard_Kim.jpg',
          },
        ],
      },
      {
        office: 'Singapore',
        salesRegion: 'South East Asia',
        adressLines: [
          '3 Temasek Avenue',
          '#24-06 Centennial Tower',
          'Singapore 039190',
        ],
        contacts: [ 
          {
            name: 'Stephanie Neubronner',
            description: 'Manager, South East Asia',
            telephone: '65 6737 6696',
            mail: 'sneubronner@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/stephanie.png',
          },
        ],
      },
      {
        office: 'Shanghai',
        salesRegion: 'Shanghai',
        adressLines: [
          'Suite 342, Shanghai Center',
          '1376 Nanjing Road West',
          'Shanghai 200040, China',
        ],
        contacts: [
          {
            name: 'Fiza Han',
            description: 'Managing Director, Greater China',
            telephone: '86 21 6279 8950',
            mail: 'fhan@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/Fiza.jpg',
          },
          {
            name: 'Candy Chen',
            description: 'Director of Sales - Eastern China',
            telephone: '86 21 6279 8956',
            mail: 'cchen@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/Candy_Chen.jpg',
          },
          {
            name: 'Michael Xu',
            description: 'Senior Sales Manager - Eastern China',
            telephone: '86 21 6279 8957',
            mail: 'mxu@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/michael.png',
          },
        ],
      },
      {
        office: 'Beijing',
        salesRegion: 'Beijing',
        adressLines: [
          'Suite 342, Shanghai Center',
          '1376 Nanjing Road West',
          'Shanghai 200040, China',
        ],
        contacts: [
          {
            name: 'Angelina An',
            description: 'Senior Sales Manager - Northern China',
            telephone: '86 10 5907 1655',
            mail: 'aan@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/angelina.png',
          },
        ],
      },
      {
        office: 'Chengdu',
        salesRegion: 'Chengdu',
        adressLines: [
          'Suite 342, Shanghai Center',
          '1376 Nanjing Road West',
          'Shanghai 200040, China',
        ],
        contacts: [
          {
            name: 'Alan Wang',
            description: 'Senior Sales Manager - Western China',
            telephone: '86 136 6622 7795',
            mail: 'awang@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/678/Laura%20Hildmann%20-%20Alan%20Wang.jpg',
          },
        ],
      },
      {
        office: 'Hong Kong',
        salesRegion: 'Hong Kong & Taiwan',
        adressLines: [
          'Suite 1017, 10/F',
          'Sun House',
          '181 Des Voeux Road Central, Hong Kong, SAR',
        ],
        contacts: [
          {
            name: 'Fiza Han',
            description: 'Managing Director, Greater China',
            telephone: '852 2191 9696',
            mail: 'fhan@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/Fiza.jpg',
          },
          {
            name: 'Carol Leung',
            description: 'Senior Sales Manager - Hong Kong & Taiwan',
            telephone: '852 2810 9791',
            mail: 'cleung@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/carol.png',
          },
        ],
      },
      {
        office: 'India',
        salesRegion: 'India',
        adressLines: [],
        contacts: [
          {
            name: 'Deepak Arora',
            description: 'Director, India',
            telephone: '91 22 40779214 / 9234',
            mail: 'darora@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/678/Laura%20Hildmann%20-%20Deepak%20Arora.JPG',
          },
        ],
      },
      {
        office: 'sydney',
        salesRegion: 'Australia & New Zealand',
        adressLines: [
          'Suite 12.02, Level 12',
          '227 Elizabeth Street',
          'Sydney 2000, NSW, Australia',
        ],
        contacts: [
          {
            id: 1,
            name: 'Craig Adamson',
            description: 'Managing Director, Asia Pacific (excl. China)',
            telephone: '61 2 9377 8400',
            mail: 'cadamson@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/678/Laura%20Hildmann%20-%20Craig%20Adamson.Jpg',
          },
          {
            id: 2,
            name: 'Renee Fowler',
            description: 'Associate Manager, Sales',
            telephone: '61 2 9377 8400',
            mail: 'rfowler@lhw.com',
            town: 'Sydney',
            imageUrl:
              'https://front.travpromobile.com/678/Laura%20Hildmann%20-%20ReneeFowler.jpg',
          },
        ],
      },
    ],
  },
  samer: {
    name: 'Latin America',
    reservationsInfo: [
      {
        country: 'Argentina',
        telephone: '0-800-333-4611 toll free',
      },
      {
        country: 'Bolivia',
        telephone: '800 100 598 toll free',
      },
      {
        country: 'Brazil',
        telephone: '0800-014-18-19 toll free',
      },
      {
        country: 'Chile',
        telephone: '800-570-277 toll free',
      },
      {
        country: 'Colombia',
        telephone: '01-800-754-1376 toll free',
      },
      {
        country: 'Costa Rica',
        telephone: '0800-054-2036 toll free',
      },
      {
        country: 'Dominican Republic',
        telephone: '1 800-751-3353 toll free',
      },
      {
        country: 'Ecuador',
        telephone: '1-800-300-100 toll free',
      },
      {
        country: 'El Salvador',
        telephone: '800-6-534 toll free',
      },
      {
        country: 'Mexico',
        telephone: '01-800-062-5027 toll free',
      },
      {
        country: 'Panama',
        telephone: '011 00800-054-0365 toll free',
      },
      {
        country: 'Paraguay',
        telephone: '009-800-542-0009 toll free',
      },
      {
        country: 'Peru',
        telephone: '0-800-50781 toll free',
      },
      {
        country: 'Uruguay',
        telephone: '000-4054-256 toll free',
      },
      {
        country: 'Venezuela',
        telephone: '0-800-100-5606 toll free',
      },
    ],
    offices: [
      {
        office: 'São Paulo',
        salesRegion: 'Brazil',
        adressLines: [
          'Al. Santos 1773',
          'Sala 1207',
          '01419-002 São paulo SP',
          'Brazil',
        ],
        contacts: [
          {
            name: 'João Annibale',
            description: 'Senior Regional Director, Brazil',
            telephone: '0800 014 1819',
            mail: 'jannibale@lhw.com ',
            imageUrl: 'https://front.travpromobile.com/678/joao.png',
          },
          {
            name: 'Giovana Mikelaitis',
            description: 'Senior Manager, Corporate Sales',
            telephone: '55 11 98263-2647',
            mail: 'gmikelaitis@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/giovana.png',
          },
          {
            name: 'George Chiminazzo',
            description: 'Manager, Sales',
            telephone: '55 11 94275-3362',
            mail: 'gchiminazzo@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/george.png',
          },
        ],
      },
      {
        office: 'Buenos Aires',
        salesRegion: 'Spanish Speaking Countries in Latin America',
        adressLines: [
          'Esmeralda 920, Of.2706',
          'C1007ABL Buenos Aires',
          'Argentina',
        ],
        contacts: [
          {
            name: 'Enrique Espinosa Solar',
            description: 'Senior Sales Manager',
            telephone: '54 11 7078 0080',
            mail: 'esolar@lhw.com ',
            imageUrl:
              'https://front.travpromobile.com/678/Laura%20Hildmann%20-%20Enrique%20Espinosa%20Solar.jpg',
          },
          {
            name: 'Cecilia Attwell',
            description: 'Sales Manager',
            telephone: '54 11 7078 0080',
            mail: 'cattwell@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/678/Laura%20Hildmann%20-%20Cecilia%20Attwell.jpg',
          },
        ],
      },
      {
        office: 'Mexico',
        salesRegion: 'Mexico',
        adressLines: [
          'Juan Vazquez de Mella 481',
          'Piso 2, Oficina 200A',
          'Col. Los Morales Polanco, Miguel Hidalgo',
          '11510, Ciudad de México',
        ],
        contacts: [
          {
            name: 'Yamile Felix',
            description: 'Senior Sales Manager',
            telephone: '52 55 2122 2771',
            mail: 'yfelix@lhw.com ',
            imageUrl:
              'https://front.travpromobile.com/678/Laura%20Hildmann%20-%20Yamile%20Felix.jpg',
          },
        ],
      },
    ],
  },
  namer: {
    name: 'North America',
    reservationsInfo: [
      {
        country: 'North America',
        telephone: '1-800-223-6800 toll free',
      },
    ],
    offices: [
      {
        office: 'New York City',
        salesRegion: 'Eastern Region',
        adressLines: [
          '485 Lexington Avenue',
          'New York, New York 10017 U.S.A.',
        ],
        contacts: [
          {
            name: 'Paolo Paolillo',
            description: 'Senior Manager Travel <br /> Trade Eastern Region',
            telephone: '1 310 779 6823',
            mail: 'ppaolillo@lhw.com',
            imageUrl: 'http://front.travpromobile.com/678/paolo.png',
          },
          {
            name: 'Jessica Rosen',
            description: 'Manager Travel Trade Eastern Region',
            telephone: '1 212 515 5645',
            mail: 'jrosen@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/678/jrosen.png',
          },
        ],
      },
      {
        office: 'Los Angeles',
        salesRegion: 'Western Region',
        adressLines: [],
        contacts: [
          {
            name: 'Remy Papazian',
            description: 'Director Travel Trade, North America',
            telephone: '1 310 576 7098',
            mail: 'rpapazian@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/remy.png',
          },
          {
            name: 'Caitlin Murphy',
            description: 'Senior Manager Travel Trade Western Region',
            telephone: '1 310 576 7098',
            mail: 'cmurphy@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/678/Laura%20Hildmann%20-%20Caitlin%20Murphy.jpg',
          },
          {
            name: 'Svetlana Thein',
            description: 'Specialist Entertainment Sales',
            telephone: '1 310 576 7098',
            mail: 'sthein@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/Svetlana+Thein.jpg',
          },
        ],
      },
    ],
  },
  europe: {
    name: 'Europe',
    reservationsInfo: [
      {
        country:
          'Austria, Belgium, Denmark, France, Germany, Holland, Ireland, Italy, Luxembourg, Norway, Portugal, Spain, Sweden, Switzerland, and United Kingdom',
        telephone: '00-800-2888-8882 toll free',
      },
      {
        country: 'Czech Republic',
        telephone: '800-05-03-79 toll free',
      },
      {
        country: 'Greece',
        telephone: '00-800-39-127-0617 toll free',
      },
      {
        country: 'Israel',
        telephone: '180-945-4488 toll free',
      },
      {
        country: 'Liechtenstein',
        telephone: '0800-551123 toll free',
      },
      {
        country: 'Monaco',
        telephone: '0-800-136-136 toll free',
      },
      {
        country: 'Russia',
        telephone: '(7-495) 937-54-37',
      },
      {
        country: 'Turkey',
        telephone: '00-800-39-9075252 toll free',
      },
      {
        country: 'Ukraine',
        telephone: '0800-300-888 toll free',
      },
    ],
    offices: [
      {
        isGroupedContact: true,
        salesRegion: 'UK, Ireland, Nordics, Portugal & Spain',
        adressLines: [],
        telephone: ['33 1 53 67 10 10'],
        contacts: [
          {
            name: 'Marie-Pierre Morelle',
            description: 'Director Travel Trade, Europe',
            mail: 'mpmorelle@lhw.com',
            telephone: '33 6 75 49 08 39',
            imageUrl:
              'https://front.travpromobile.com/678/Laura%20Hildmann%20-%20Marie-Pierre%20Morelle.jpg',
            region: 'France, UK, Spain, Portugal and Italy'
          },
          {
            name: 'Emilie Weisser',
            description: 'Senior Sales Manager',
            mail: 'eweisser@lhw.com',
            telephone: '33 7 88 67 37 76',
            imageUrl:
              'https://front.travpromobile.com/678/Emilie.jpg',
            region: 'DACH, Benelux and Nordics countries'
          },
        ],
      },
      {
        isGroupedContact: true,
        office: 'Paris',
        salesRegion: 'France, Monaco & Benelux',
        adressLines: [
          'KWERK Haussmann',
          '29-31, rue de Courcelles',
          '75008 Paris, France',
        ],
        telephone: ['33 1 53 67 10 10'],
        contacts: [],
      },
      {
        isGroupedContact: true,
        office: 'Frankfurt',
        salesRegion: 'Germany, Switzerland, Austria & Central Eastern Europe',
        adressLines: ['Berliner Strasse 44', '60311 Frankfurt, Germany'],
        telephone: ['49 69 138 85 100'],
        contacts: [],
      },
      {
        isGroupedContact: true,
        office: 'Milan',
        salesRegion: 'Italy and Southeast Europe',
        adressLines: ['Via Manuzio, 7', '20124 Milan, Italy'],
        telephone: ['39 02 669 86131'],
        contacts: [],
      },
      {
        office: 'Moscow',
        salesRegion: 'Russia, Ukraine & CIS',
        adressLines: ['Pushkarev lane 9', '127051 Moscow, Russia'],
        contacts: [
          {
            name: 'Valeri Ishunkin',
            description:
              'Senior Director - Eastern Europe, Russia, Ukraine, CIS and Israel',
            telephone: '7 495 933 28 21',
            mail: 'vishunkin@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/valeri.png',
          },
          {
            name: 'Natalia Vedishcheva',
            description:
              'Senior Sales Manager - Eastern Europe, Russia, Ukraine, CIS and Israel ',
            telephone: '7 495 933 28 21',
            mail: 'nvedishcheva@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/natalia.png',
          },
        ],
      },
    ],
  },
  mea: {
    name: 'Middle East and Africa',
    reservationsInfo: [
      {
        country: 'Bahrain',
        telephone: '8000-4086 toll free',
      },
      {
        country: 'Kuwait',
        telephone: '6632-9932 toll free',
      },
      {
        country: 'Qatar',
        telephone: '00800-971-008 toll free',
      },
      {
        country: 'Saudi Arabia',
        telephone: '800-897-1488 toll free',
      },
      {
        country: 'United Arab Emirates',
        telephone: '800-532-3464 toll free',
      },
    ],
    offices: [
      {
        office: 'Dubai',
        salesRegion: 'Middle East & Africa',
        adressLines: [
          'Knowledge Village',
          'Al Sufouh Road',
          'Block 19, Office Number T14 (03rd floor)',
          'Dubai, United Arab Emirates',
        ],
        contacts: [
          {
            name: 'Hatem Chatter',
            description: 'Senior Director, Middle East & Africa',
            telephone: '971 4 366 1255 ',
            mail: 'hchatter@lhw.com ',
            imageUrl: 'https://front.travpromobile.com/678/hatem.png',
          },
          {
            name: 'Gazafi EL Sheikh',
            description: 'Sales Manager, KSA & Qatar',
            telephone: '971 4 366 1255 ',
            mail: 'gsheikh@lhw.com ',
            imageUrl: 'https://front.travpromobile.com/678/gazaf.png',
          },
          {
            name: 'Mélissa Semaan',
            description: 'Sales Manager, UAE',
            telephone: '971 4 366 1255 ',
            mail: 'msemaan@lhw.com',
            imageUrl: 'https://front.travpromobile.com/678/melissa.png',
          },
        ],
      },
    ],
  },
};

const returnRegion = region => {
  const { asia, samer, namer, europe, australia, mea } = regions;
  switch (region) {
    case 'namer':
      return <Region name={namer.name} offices={namer.offices} />;
    case 'samer':
      return <Region name={samer.name} offices={samer.offices} />;
    case 'europe':
      return <Region name={europe.name} offices={europe.offices} />;
    case 'australia':
      return <Region name={australia.name} offices={australia.offices} />;
    case 'mea':
      return <Region name={mea.name} offices={mea.offices} />;
    case 'asia':
      return <Region name={asia.name} offices={asia.offices} />;
    default:
      return <p>Please Select a region</p>;
  }
};

const returnReservationsInfo = region => {
  const { asia, samer, namer, europe, australia, mea } = regions;
  switch (region) {
    case 'namer':
      return (
        <ReservationsInfo
          name={namer.name}
          reservationsInfo={namer.reservationsInfo}
        />
      );
    case 'samer':
      return (
        <ReservationsInfo
          name={samer.name}
          reservationsInfo={samer.reservationsInfo}
        />
      );
    case 'europe':
      return (
        <ReservationsInfo
          name={europe.name}
          reservationsInfo={europe.reservationsInfo}
        />
      );
    case 'australia':
      return (
        <ReservationsInfo
          name={australia.name}
          reservationsInfo={australia.reservationsInfo}
        />
      );
    case 'mea':
      return (
        <ReservationsInfo
          name={mea.name}
          reservationsInfo={mea.reservationsInfo}
        />
      );
    case 'asia':
      return (
        <ReservationsInfo
          name={asia.name}
          reservationsInfo={asia.reservationsInfo}
        />
      );
    default:
      return '';
  }
};

export default class ContactView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRegion: 'namer',
    };
  }

  handleSelectRegion = region => {
    this.setState(state => ({
      selectedRegion: region,
    }));
  };

  render() {
    const { selectedRegion } = this.state;
    const params = new URLSearchParams(window.location.search);

    return (
      <div className='contentContainer contact'>
        <div className='contacts'>
          <button
            onClick={() => this.handleSelectRegion('namer')}
            className='button'
          >
            <h1 className='head'>North-America</h1>
          </button>
          <button
            onClick={() => this.handleSelectRegion('samer')}
            className='button'
          >
            <h1 className='head'>Latin-America</h1>
          </button>
          <button
            onClick={() => this.handleSelectRegion('europe')}
            className='button'
          >
            <h1 className='head'>Europe</h1>
          </button>
          <button
            onClick={() => this.handleSelectRegion('asia')}
            className='button'
          >
            <h1 className='head'>Asia Pacific</h1>
          </button>
          <button
            onClick={() => this.handleSelectRegion('mea')}
            className='button'
          >
            <h1 className='head'>Middle-East and Africa</h1>
          </button>
        </div>
        <div className='contactView__Header' />
        <div className='reservations_info'>
          {returnReservationsInfo(selectedRegion)}
        </div>
        <div className='contacts contactItems'>
          {returnRegion(selectedRegion)}
        </div>
        {params.get('header') === 'false' && (
          <style>
            {
              '\
        .header { display: none; } .contact { margin-top: 0rem !important; }'
            }
          </style>
        )}
      </div>
    );
  }
}